export const SHOW_SIGN_IN_FORM = 'SHOW_SIGN_IN_FORM';
export const HIDE_SIGN_IN_FORM = 'HIDE_SIGN_IN_FORM';
export const GET_USER = 'GET_USER';
export const GET_USER_AUTH_DATA = 'GET_USER_AUTH_DATA';
export const USER_DATA_LOADING = 'USER_DATA_LOADING';
export const USER_DATA_LOADING_FAIL = 'USER_DATA_LOADING_FAIL';
export const SWITCH_TO_USER_PROFILE = 'SWITCH_TO_USER_PROFILE';
export const LOGOUT = 'LOGOUT';

// Contacts page actions
export const SET_TILED_VIEW = 'SET_TILED_VIEW';
export const SET_TABLE_VIEW = 'SET_TABLE_VIEW';
export const CONTACTS_LOADING = 'CONTACTS_LOADING';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
export const CONTACTS_LOADING_FAIL = 'CONTACTS_LOADING_FAIL';
export const PAGINATE = 'PAGINATE';
export const GO_TO_CONTACT_PAGE = 'GO_TO_CONTACT_PAGE';
export const GET_SELECTED_CONTACT_NUMBER = 'GET_SELECTED_CONTACT_NUMBER';

// Filter actions
export const FILTER_BY_GENDER = 'FILTER_BY_GENDER';
export const FILTER_BY_NATIONALITY = 'FILTER_BY_NATIONALITY';
export const FILTER_BY_NAME = 'FILTER_BY_NAME';
export const CLEAR_FILTERS_FORM = 'CLEAR_FILTERS_FORM';
